export enum FilterType {
  sortId,
  cid,
}

export enum UserType {
  Customer = 'Customer',
  Vendor = 'Vendor', // brand
  CustomerService = 'CustomerService', // Customer Service
}

export enum Sort {
  MostHelpful = 1,
  Newest = 2,
  Oldest = 3,
  NewlyAnswered = 4,
  MostRelevant,
}
export const defaultSort = Sort.MostRelevant;

export interface IFilter {
  id: number;
  name: string;
}

export interface IProfileInfo {
  image: {
    thumbnails: { fullPath: string }[];
  };
}
// answer type
export const defaultAnswer = {
  id: '',
  questionId: '',
  userType: UserType.Customer,
  content: '',
  customerNickname: '',
  customerProfileLink: '',
  postedDateLocalized: '',
  hasRewarded: false,
  helpfulNo: 0,
  helpfulYes: 0,
  verifiedPurchase: false,
  isBest: false,
  profileImageUrl: '',
  answerShareUrl: '',
};

export interface IAnswer {
  id: string;
  questionId: string;
  userType: UserType;
  content: string;
  customerNickname: string;
  customerProfileLink: string;
  postedDateLocalized: string;
  hasRewarded: boolean;
  hasThumbsUp: boolean | null;
  helpfulNo: number;
  helpfulYes: number;
  verifiedPurchase?: boolean;
  isBest?: boolean;
  profileImageUrl: string; //deal profileInfo api params
  answerShareUrl: string; //deal from params
}
// question type
export const defaultQuestionInfo = {
  id: '',
  content: '',

  postedDateLocalized: '',
  answerCount: 0,
  questionShareUrl: '',
  answersIdList: [],
  answersDetail: {},
};

export interface IQuestionInfo {
  id: string;
  content: string;

  postedDateLocalized: string;
  answerCount: number;
  questionShareUrl: string; //deal from params
  answersIdList: (string | null)[];
  answersDetail: {
    [key: string]: IAnswer;
  }; //deal answers,customerServiceAnswer,vendorAnswer api params
}
// api response type
export interface IQuestionList {
  items: Array<any>;
  totalCount: number;
}
